import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { apiService } from '../utils/api';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login, setOrganizations } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      const token = searchParams.get('token');

      if (!token) {
        navigate('/expired-link');
        return;
      }

      try {
        const response = await apiService.validateToken(token);

        if (response.success && response.email && response.organizations) {
          // Log the user in
          login(response.email, token);
          setOrganizations(response.organizations);

          // Redirect to dashboard
          navigate('/dashboard');
        } else {
          navigate('/expired-link');
          return;
        }
      } catch (error) {
        console.error('Token validation error:', error);
        navigate('/expired-link');
        return;
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [searchParams, login, setOrganizations, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600" aria-live="polite">
            Authenticating...
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default Auth;
